module.exports = __webpack_public_path__ + "img/d20071023b-1.e3349777.jpg";